import Controller from '../../shared/logic/Controller';
import Filter from '../../shared/model/filter/Filter';

export const className = 'Filters';
export const dependenciesRunInState = '--NA';

export default class Filters extends Controller {
  run = async (dependencies, dependenciesForAngular) => {
    const isInRunnableState = await this.init(
      [],
      dependencies,
      dependenciesForAngular,
      dependenciesRunInState
    );
    if (!isInRunnableState) {
      return;
    }
    this.Scope.set(
      {
        isReady: { Filters: true }
      },
      true
    );
  };

  constructor(
    $rootScope,
    $scope,
    $state,
    $timeout,
    webpage,
    eventService,
    authenticationService
  ) {
    'ngInject';

    const angularDependencies = [
      $rootScope,
      $scope,
      $state,
      $timeout,
      webpage,
      eventService,
      authenticationService
    ];
    super(angularDependencies, {
      Storage: {
        Table: className
      },
      Scope: {
        Defaults: {
          Name: className
        }
      },
      Data: {
        Model: Filter,
        ModelName: className,
        Requests: {
          available: {
            url: '/api/v1/filters/available/',
            query: {
              orderBy: 'name',
              coerceTo: 'string',
              isDescending: false
            }
          }
        }
      }
    });

    this.run([], angularDependencies);
  }
}
